import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router";
import { Button } from "@mui/material";
import { useApi } from "../../hooks/useApi";
import type { OnboardingListRow } from "../../types/onboarding";
import { toOpenOnboardingsUrl } from "./useOpenCompanyOnboarding";

export default function OnboardingButton({ companyId }: { companyId: number }) {
  const { get } = useApi();
  const [data, setData] = useState<OnboardingListRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let current = true;
    setData(null);
    setError(null);
    get<OnboardingListRow[]>(toOpenOnboardingsUrl(companyId))
      .then((rows) => { if (current) setData(rows); })
      .catch((err: Error) => { if (current) setError(err.message); });
    return () => { current = false; };
  }, [get, companyId]);

  if (error) return <span className="text-sm text-error-600">Could not check the onboarding: {error}</span>;
  if (!data) return null;
  return data.length === 0 ? (
    <Button component={RouterLink} to={`/onboarding/new/${companyId}`} variant="outlined">Start onboarding</Button>
  ) : (
    <Button component={RouterLink} to={`/onboarding/${data[0].onboardingId}`} variant="outlined">Open onboarding</Button>
  );
}
